import type { CheckoutItem } from "../model/CheckoutData";
import type { MovPerSupplierInfo } from "../model/CommonCartTypes";
export type CountableItem = {
	readonly chargedByWeight: boolean;
	readonly quantity: number;
	readonly supplierId: string;
};
export type ItemCount = {
	articleCount: number;
	unitCount: number;
	checkoutReadyArticleCount: number;
};
export function getCheckoutItemCount(items: Record<string, CheckoutItem> | null | undefined): ItemCount {
	let articleCount = 0;
	let unitCount = 0;

	if (items) {
		for (const btyId in items) {
			const item: CheckoutItem = items[btyId];
			unitCount += item.isWeighted ? 1 : item.quantity;
		}

		articleCount = Object.keys(items).length;
	}

	return {
		articleCount,
		unitCount,
		checkoutReadyArticleCount: articleCount,
	};
}
export function getCartItemCount(
	items: CountableItem[] | null | undefined,
	movPerSupplierInfo?: MovPerSupplierInfo,
): ItemCount {
	let articleCount = 0;
	let unitCount = 0;
	let checkoutReadyArticleCount = 0;

	if (items) {
		for (const item of items) {
			unitCount += item.chargedByWeight ? 1 : item.quantity;
			const sumIsAboveMov = movPerSupplierInfo?.supplierToMovInfo[item.supplierId]?.sumIsAboveMov ?? true;
			if (sumIsAboveMov) {
				checkoutReadyArticleCount++;
			}
		}

		articleCount = items.length;
	}

	return {
		articleCount,
		unitCount,
		checkoutReadyArticleCount,
	};
}
